module.exports = __webpack_public_path__ + "static/media/bil1_img8.a0023d07.JPG";